<template>
  <div class="header-wrapper">
    <div class="map-tool-bar">
      <ul>
        <li @click="createNewFeature('Point')" v-if="username">
          <span class="fa fa-map-marker"></span> 新增点
        </li>
        <li class="line" v-if="username"></li>
        <li @click="createNewFeature('LineString')" v-if="username">
          <span class="fa fa-level-down"></span> 新增线
        </li>
        <li class="line" v-if="username"></li>
        <li @click="createNewFeature('Polygon')" v-if="username">
          <span class="fa fa-object-ungroup"></span> 新增面
        </li>
        <li class="line" v-if="username"></li>
        <li @click="createNewFeature('Polygon')" v-if="username">
          <span class="fa fa-object-ungroup"></span> 新增乡镇
        </li>
        <li class="line" v-if="username"></li>
        <li @click="measure('LineString')" title="测距里">
          <span class="fa fa-arrows-h"></span> 测距里
        </li>
        <li class="line" title="测面积"></li>
        <li @click="measure('Polygon')">
          <span class="fa fa-crop"></span>测面积
        </li>
        <li class="line"></li>
        <li @click="refreash()"><span class="fa fa-trash"></span>清空</li>
        <li class="line"></li>
        <li @click="addLocalVectorData()" title="加载本地矢量文件">
          <span class="fa fa-file-code-o"></span>矢量文件
        </li>
        <li class="line"></li>
        <li @click="printDialogVisible = true">
          <span class="fa fa-print"></span>地图打印
        </li>
      </ul>

      <el-dialog
        title="地图将输出为pdf文件"
        :visible.sync="printDialogVisible"
        width="30%"
        :modal="false"
      >
        <div>
          <div class="print-title">纸张大小</div>
          <el-radio-group v-model="PageSize">
            <el-radio label="A4">A4(推荐)</el-radio>
            <el-radio label="A3">A3</el-radio>
            <el-radio label="A2">A2</el-radio>
            <el-radio label="A1">A1</el-radio>
            <el-radio label="A0">A0</el-radio>
          </el-radio-group>
        </div>
        <div>
          <div class="print-title">地图分辨率</div>
          <el-radio-group v-model="Resolution">
            <el-radio label="72">72dpi(一般)</el-radio>
            <el-radio label="150">150dpi(中等)</el-radio>
            <el-radio label="300">300dpi(高质量)</el-radio>
          </el-radio-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="printDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="print()">打 印 地 图</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { toJpeg } from "html-to-image";
import * as jsPDF from "jspdf";
import { getArea, getLength } from "ol/sphere";
import { LineString, Polygon } from "ol/geom";
import Draw from "ol/interaction/Draw";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { unByKey } from "ol/Observable";
import Overlay from "ol/Overlay";
import WKT from "ol/format/WKT";

import tool_measure from "./measure.js";
export default {
  name: "MapToolBar",
  props: {},
  data() {
    return {
      map: null,
      printDialogVisible: false,
      PageSize: "A4",
      Resolution: "72",
      drawSource: null,
      drawLayer: null,
      featureType: "length",
      ispPrinting: false,
    };
  },
  watch: {},
  computed: {
    username() {
      return this.$store.state.userName;
    },
    showAddLocalVectorData() {
      return this.$store.state.showAddLocalVectorData;
    },
  },
  components: {},
  methods: {
    addLocalVectorData() {
      this.$store.commit(
        "setShowAddLocalVectorData",
        !this.showAddLocalVectorData
      );
    },
    print() {
      if (this.ispPrinting) {
        this.$notify({
          title: "系统忙",
          message: "已有地图在打印队列中,请您稍后。",
          type: "warning",
          duration: 0,
        });
        this.printDialogVisible = false;
        return;
      }
      this.ispPrinting = true;
      this.$notify({
        title: "地图打印",
        message: "地图打印中，请等待！",
        type: "success",
        duration: 0,
      });
      let dims = {
        A0: [1189, 841],
        A1: [841, 594],
        A2: [594, 420],
        A3: [420, 297],
        A4: [297, 210],
      };
      let exportOptions = {
        filter: function (element) {
          let result = element.className.indexOf("ol-control") === -1;
          return result;
        },
      };
      document.body.style.cursor = "progress";
      var format = this.PageSize;
      var resolution = this.Resolution;
      var dim = dims[format];
      var width = Math.round((dim[0] * resolution) / 25.4);
      var height = Math.round((dim[1] * resolution) / 25.4);
      var size = this.xxMap.getMainMap().getSize();
      var viewResolution = this.xxMap.getMainMap().getView().getResolution();
      exportOptions.width = width;
      exportOptions.height = height;
      //地图加载完 才能打印   受网速影响
      this.xxMap.getMainMap().once("rendercomplete", () => {
        var mapCanvas = document.createElement("canvas");
        mapCanvas.width = width;
        mapCanvas.height = height;
        var mapContext = mapCanvas.getContext("2d");
        Array.prototype.forEach.call(
          document.querySelectorAll(".ol-layer canvas"),
          (canvas) => {
            if (canvas.width > 0) {
              var opacity = canvas.parentNode.style.opacity;
              mapContext.globalAlpha = opacity === "" ? 1 : Number(opacity);
              var transform = canvas.style.transform;
              var matrix = transform
                .match(/^matrix\(([^\(]*)\)$/)[1]
                .split(",")
                .map(Number);
              CanvasRenderingContext2D.prototype.setTransform.apply(
                mapContext,
                matrix
              );
              mapContext.drawImage(canvas, 0, 0);
            }
          }
        );
        var pdf = new jsPDF("landscape", undefined, format);
        pdf.addImage(
          mapCanvas.toDataURL("image/jpeg"),
          "JPEG",
          0,
          0,
          dim[0],
          dim[1]
        );
        pdf.save("您导出的地图.pdf");
        this.xxMap.getMainMap().setSize(size);
        this.xxMap.getMainMap().getView().setResolution(viewResolution);
        document.body.style.cursor = "auto";
        this.ispPrinting = false;
        this.$notify({
          title: "成功",
          message: "地图打印成功",
          type: "success",
          duration: 0,
        });
      });
      this.printDialogVisible = false;
      var printSize = [width, height];
      this.xxMap.getMainMap().setSize(printSize);
      var scaling = Math.min(width / size[0], height / size[1]);
      this.xxMap
        .getMainMap()
        .getView()
        .setResolution(viewResolution / scaling);
    },
    measure(type) {
      tool_measure.map = this.xxMap.getMainMap();
      tool_measure.startMeasure(type);
    },
    refreash() {
      tool_measure.clear();
      if (this.drawLayer) {
        this.drawLayer.getSource().clear();
      }
      this.xxMap.getMainMap().getOverlays().clear();
      this.$store.commit("setNewGeom", "");
    },

    //绘制新的要素
    addDrawFeatureInteraction() {
      if (this.draw != null) {
        this.xxMap.getMainMap().removeInteraction(this.draw);
      }
      this.initDraw();

      this.draw = new Draw({
        source: this.drawSource,
        type: this.featureType,
        style: new Style({
          fill: new Fill({
            color: "#efbf3a7d",
          }),
          stroke: new Stroke({
            color: "red",
            lineDash: [10, 10],
            width: 2,
          }),
          image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
              color: "rgba(255, 255, 255, 0.7)",
            }),
            fill: new Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
          }),
        }),
      });

      this.map.addInteraction(this.draw);

      this.draw.on("drawend", (e) => {
        var wkt = new WKT().writeFeatureText(e.feature);
        this.$store.commit("setNewGeom", wkt);
        this.$store.commit("setNewFeatureType", this.featureType);
        this.$emit("toggleNewFeaturePanel", true);
        this.map.removeInteraction(this.draw);
      });
    },

    initDraw() {
      if (this.drawLayer != null) {
        return;
      } else {
        this.drawSource = new VectorSource();
        this.drawLayer = new VectorLayer({
          source: this.drawSource,
          zIndex: 999,
          style: new Style({
            fill: new Fill({
              color: "#efbf3a7d",
            }),
            stroke: new Stroke({
              color: "red",
              width: 2,
            }),
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({
                color: "#ffcc33",
              }),
            }),
          }),
        });
        this.map.addLayer(this.drawLayer);
      }
    },

    createNewFeature(featureType) {
      this.refreash();
      this.featureType = featureType;
      let that = this;
      this.addDrawFeatureInteraction();
    },

    toggleLayerManage() {
      this.$emit("toggleLayerManage", null);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less" >
.header-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;
  height: 35px;
  background: #ffffff;
  line-height: 35px;
  color: #0b0b0b;
}
.map-tool-bar {
  display: inline-block;
  width: 100%;
  height: 35px;
  ul {
    list-style: none;
    padding-inline-start: 5px;
    display: inline-block;
    font-size: 15px;
    li {
      float: left;
      padding: 0 10px;
      span {
        margin-right: 5px;
      }
    }
    li:hover {
      cursor: pointer;
      color: rgb(139, 159, 248);
    }
    li.line {
      border-right: solid 1px #ddd;
      height: 16px;
      margin: 9px 5px 7px 5px;
      padding: 0;
    }
  }
  .search {
    float: right;
    height: 30px;
    margin-right: 10px;
    /deep/.el-input-group__append {
      padding: 0 7px;
    }
  }
}
.print-title {
  font-weight: bold;
  margin: 10px 0;
}
</style>

 